<template>
  <div
    id="app"
    class="window-narrow"
    :class="{
      'in-shell': isElectron,
    }"
  >
    <!-- <div v-show="showLoading" class="page-loading" @click="hideLoading">
      <span><i></i><i></i><i></i><i></i></span>
    </div> -->
    <router-view />
    <el-dialog
      :title="!isEnd ? '发现新版本!' : '下载完成'"
      :visible.sync="dialogVisible"
      :show-close="false"
      width="300px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div v-if="!isEnd">
        <p>v3.0.0</p>
        <p>1、老板说要优化，我就优化了</p>
        <p>2、反正我觉得比以前要好用</p>
      </div>
      <div v-if="isEnd">
        <p>最新版本已经下载好了</p>
        <p>旧版的还留着干啥，赶紧卸了</p>
        <p>如有问题，请联系客服Q642158787</p>
      </div>
      <!-- <p v-if="!isEnd" style="font-size:12px;margin-top:10px">
        *最好先卸载旧版，再装新版（不会丢失数据）
      </p> -->
      <div slot="footer" class="dialog-footer" v-if="!showProgress">
        <el-link
          type="primary"
          @click="downClick(true)"
          style="margin-right:30px"
          >Mac版下载</el-link
        >
        <el-button type="primary" @click="downClick(false)"
          >电脑版下载</el-button
        >
      </div>
      <div class="row-padding">
        <el-progress
          :text-inside="true"
          :stroke-width="26"
          :percentage="percentage"
          v-if="showProgress && !isEnd"
        ></el-progress>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { cv } from "@/api/index";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      showProgress: false,
      percentage: 0,
      dialogVisible: false,
      isEnd: false,
    };
  },
  computed: {
    ...mapState({
      isElectron: (state) => state.isElectron,
      showLoading: (state) => state.showLoading,
    }),
  },
  created() {},
  mounted() {
    setTimeout(() => {
      try {
        console.log(">>>", localStorage.getItem("xhd_new"));
        if (
          localStorage["xhd_personal"]
            ? JSON.parse(localStorage["xhd_personal"])
            : false
        ) {
          console.log(window.electron.remote.app.getVersion());
          if (
            window.electron &&
            window.electron.remote.app.getVersion() != "3.0.0"
          ) {
            console.log(window.electron.remote.app.getVersion());
            // this.dialogVisible = true
          } else {
            this.dialogVisible = false;
          }
        } else {
          this.dialogVisible = false;
        }
      } catch (e) {
        this.dialogVisible = false;
      }
    }, 1000);
    if (window.electron) {
      let version = window.electron.remote.app.getVersion();
      cv({
        v: version,
      });
    }
  },
  methods: {
    ...mapActions(["changeLoadingStatus"]),
    downClick(isMac) {
      console.log(">>>>>>", isMac);
      this.showProgress = true;
      let url = isMac
        ? "https://xhd-desktop.oss-cn-hangzhou.aliyuncs.com/desktop/xhd-desktop-setup.dmg"
        : "https://xhd-desktop.oss-cn-hangzhou.aliyuncs.com/desktop/xhd-desktop-setup.exe";
      // window.electron.shell.openExternal(url);
      const x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onprogress = (event) => {
        // btn.innerHTML = `下载${(
        //     (event.loaded / event.total) *
        //     100
        // ).toFixed(2)}%`;
        console.log(123);
        this.percentage = Number(
          ((event.loaded / event.total) * 100).toFixed(2)
        );
      };
      let contentType = isMac
        ? "application/x-apple-diskimage"
        : "application/vnd.microsoft.portable-executable";
      let fileName = isMac ? "小虎弟安装包.dmg" : "小虎弟安装包.exe";
      x.onload = (e) => {
        download(x.response, fileName, contentType);
        this.isEnd = true;
        setTimeout(function() {
          window.electron && window.electron.remote.app.exit(1);
        }, 20000);
      };
      x.send();
    },
    hideLoading() {
      this.changeLoadingStatus(false);
    },
  },
};
</script>
